import { render } from "./KubernetesServiceTab.vue?vue&type=template&id=98c12e08&scoped=true"
import script from "./KubernetesServiceTab.vue?vue&type=script&lang=js"
export * from "./KubernetesServiceTab.vue?vue&type=script&lang=js"

import "./KubernetesServiceTab.vue?vue&type=style&index=0&id=98c12e08&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98c12e08"]])

export default __exports__